import { render } from "./ImportantTasks.vue?vue&type=template&id=5a279833&scoped=true"
import script from "./ImportantTasks.vue?vue&type=script&lang=js"
export * from "./ImportantTasks.vue?vue&type=script&lang=js"

import "./ImportantTasks.vue?vue&type=style&index=0&id=5a279833&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/front/intranet-gpaie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a279833"]])

export default __exports__